import { HttpErrorResponse } from "@angular/common/http";
import { isLoginError, LoginError } from "@pcp/core/interfaces";

export interface LoginFailedResponse extends HttpErrorResponse {
    error: LoginError;
}

export const isLoginFailedResponse = (response: any): response is LoginFailedResponse =>
    response instanceof HttpErrorResponse
    && isLoginError(response.error);
